import { Card, Subject } from "../types";

/**
 * 科目ごとの「つながる職業・探究テーマ」のフォールバック。
 * カード自身に career_tags が設定されていない場合に、科目から妥当な
 * テーマを補完して、常に「学びが社会のどこにつながるか」を示せるようにする。
 */
const CAREER_THEMES_BY_SUBJECT: Record<string, string[]> = {
  国語: ["編集・ライター", "弁護士", "広報・PR"],
  数学: ["データサイエンス", "エンジニア", "金融アナリスト"],
  英語: ["通訳・翻訳", "国際協力", "グローバルビジネス"],
  物理: ["研究者", "機械エンジニア", "宇宙開発"],
  化学: ["素材開発", "製薬", "環境技術"],
  生物: ["医療・看護", "農学", "バイオ研究"],
  地学: ["防災", "気象予報士", "資源・エネルギー"],
  地理: ["都市計画", "観光プランナー", "物流・商社"],
  歴史: ["学芸員", "ジャーナリスト", "政策立案"],
  公民: ["起業家", "公務員", "社会起業"],
  美術: ["デザイナー", "建築家", "アートディレクター"],
  音楽: ["音響エンジニア", "作曲・編曲", "音楽療法"],
  技術: ["プロダクト開発", "ロボティクス", "ものづくり"],
  家庭: ["栄養士", "商品企画", "ライフプランナー"],
  保健体育: ["トレーナー", "理学療法士", "スポーツ科学"],
};

/**
 * カードに紐づく職業・探究テーマを返す。
 * カード自身の career_tags を優先し、無ければ科目ベースで補完する。
 */
export const getCareerThemes = (
  card: Card | undefined,
  subjects: Subject[],
): string[] => {
  const own = card?.career_tags?.filter(Boolean) ?? [];
  if (own.length > 0) return own;

  const subjectName = subjects.find((s) => s.id === card?.subject_id)?.name;
  if (!subjectName) return [];
  return CAREER_THEMES_BY_SUBJECT[subjectName] ?? [];
};

/**
 * 関連する学問レンズを返す。
 * カード自身の related_card_ids を優先し、無ければ同じ科目の別レンズで補完する。
 */
export const getRelatedCards = (
  card: Card | undefined,
  allCards: Card[],
  limit = 4,
): Card[] => {
  if (!card) return [];

  const explicit = (card.related_card_ids ?? [])
    .map((id) => allCards.find((c) => c.id === id))
    .filter((c): c is Card => Boolean(c) && c!.id !== card.id);
  if (explicit.length > 0) return explicit.slice(0, limit);

  return allCards
    .filter((c) => c.subject_id === card.subject_id && c.id !== card.id)
    .slice(0, limit);
};
